/* eslint-disable quote-props */
const ERT_CODES = {
    'ert_10': { name: '10', entity: 'ert.10' },
    'ert_20': { name: '20', entity: 'ert.20' },
    'ert_41': { name: '41', entity: 'ert.41' },
    'ert_42': { name: '42', entity: 'ert.42' },
    'ert_43': { name: '43', entity: 'ert.43' },
    'ert_45': { name: '45', entity: 'ert.45' },
    'ert_46': { name: '46', entity: 'ert.46' },
    'ert_60': { name: '60', entity: 'ert.60' },
    'ert_80': { name: '80', entity: 'ert.80' },
    'ert_-': { name: '-', entity: 'ert.empty' },
    'ert_UNKNOWN': { name: 'UNKNOWN', entity: 'ert.UNKNOWN' }
};

export default ERT_CODES;